function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import Form from "../../components/Form/Form";
import { DictText } from "../../components/Form/Text";
import { UploadWithFilename } from "../../components/Form/Upload";
import HtmlText from "../../components/HtmlText";
import { get, post } from "../../utils";
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, InputNumber, Modal, Popover, message } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { nanoid } from 'nanoid';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styles from "./index.module.css";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Reg = /^\d+(\.\d{1,2})?$/;
export var useDetail = function useDetail() {
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var orderCode = searchParams.get('orderCode');
  var ref = useRef(null);
  var ref2 = useRef(null);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = useState(nanoid()),
    _useState4 = _slicedToArray(_useState3, 2),
    renderKey = _useState4[0],
    setRenderKey = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    details = _useState6[0],
    setDetails = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    renderDetails = _useState8[0],
    setRenderDetails = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    allowShowPrice = _useState10[0],
    setAllowShowPrice = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    priceVisible = _useState12[0],
    setPriceVisible = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    searchText = _useState14[0],
    setSearchText = _useState14[1];
  var _useState15 = useState({}),
    _useState16 = _slicedToArray(_useState15, 2),
    summary = _useState16[0],
    setSummary = _useState16[1];
  var _useState17 = useState(''),
    _useState18 = _slicedToArray(_useState17, 2),
    searchWord = _useState18[0],
    setSearchWord = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    codesVisible = _useState20[0],
    setCodesVisible = _useState20[1];
  var _useState21 = useState({}),
    _useState22 = _slicedToArray(_useState21, 2),
    activeRecord = _useState22[0],
    setActiveRecord = _useState22[1];
  var valueProtectRender = useCallback(function (value, record) {
    var showPrice = data.showPrice || record.showPrice;
    return showPrice ? value == null ? '-' : value : '-';
  }, [data.showPrice]);
  useEffect(function () {
    if (orderCode) {
      getDetail(orderCode);
    }
  }, [orderCode]);
  useEffect(function () {
    getSummary(details);
  }, [details]);
  var onSearchDetail = function onSearchDetail() {
    setSearchWord(searchText);
    setRenderDetails(details.filter(function (v) {
      var _v$skuCode, _v$skuName;
      return ((_v$skuCode = v.skuCode) === null || _v$skuCode === void 0 ? void 0 : _v$skuCode.includes(searchText)) || ((_v$skuName = v.skuName) === null || _v$skuName === void 0 ? void 0 : _v$skuName.includes(searchText));
    }));
  };
  var getSummary = function getSummary(_details) {
    post({
      url: '/erp/scm/purchase/calcSum',
      data: {
        details: _details
      }
    }).then(function (_ref) {
      var code = _ref.code,
        data = _ref.data;
      if (code === 0) {
        setSummary(data);
      }
    });
  };
  var getDetail = function getDetail() {
    var _orderCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : orderCode;
    get({
      url: "/erp/scm/purchase/detail?orderCode=".concat(_orderCode)
    }).then(function (result) {
      var code = result.code,
        d = result.data;
      if (code === 0) {
        var _ref$current;
        (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.form.setFieldsValue(_objectSpread(_objectSpread({}, d), {}, {
          installSupplier: d.installSupplierCode ? {
            label: d.installSupplierName,
            value: d.installSupplierCode
          } : undefined
        }));
        setAllowShowPrice(!!d.showPrice);
        setDetails(d.details);
        setRenderDetails(d.details);
        setData(d);
      }
    }).catch(function () {});
  };
  var onSave = function onSave() {
    var _ref$current2;
    (_ref$current2 = ref.current) === null || _ref$current2 === void 0 || _ref$current2.form.validateFields().then(function (values) {
      var installContact = values.installContact,
        _values$installSuppli = values.installSupplier,
        installSupplier = _values$installSuppli === void 0 ? {} : _values$installSuppli,
        orderLogistics = values.orderLogistics,
        arrivalDate = values.arrivalDate,
        shopContact = values.shopContact,
        attachment = values.attachment;
      post({
        url: "/erp/scm/purchase/save",
        data: _objectSpread(_objectSpread({}, data), {}, {
          installContact: installContact || data.installContact ? _objectSpread(_objectSpread({}, data.installContact || {}), installContact || {}) : undefined,
          orderLogistics: data.orderLogistics || orderLogistics ? _objectSpread(_objectSpread({}, data.orderLogistics || {}), orderLogistics || {}) : undefined,
          details: details,
          arrivalDate: arrivalDate,
          attachment: attachment,
          shopContact: data.shopContact || shopContact ? _objectSpread(_objectSpread({}, data.shopContact || {}), shopContact || {}) : undefined,
          installSupplierCode: installSupplier.value || data.installSupplierCode,
          installSupplierName: installSupplier.label || data.installSupplierName
        })
      }).then(function (result) {
        var code = result.code;
        if (code === 0) {
          message.success('保存成功！');
          getDetail();
        }
      }).catch(function () {});
    }).catch(function () {});
  };
  var onSubmit = function onSubmit(text, path) {
    var _ref$current3;
    var bool = false;
    var name = '';
    details.forEach(function (e) {
      if (Number(e.salesPrice) < Number(e.price)) {
        bool = true;
        if (e.skuName) {
          name = e.skuName;
        }
      }
    });

    // 直配时，无需校验销售价格不允许低于含税单价
    if (data.dispatchMethod !== 'PSLXZP' && bool && data.canEditSalesPrice) {
      Modal.warning({
        className: styles.modal,
        title: "\u8BF7\u6CE8\u610F\uFF01",
        content: /*#__PURE__*/_jsxs("span", {
          style: {
            color: '#6E707A'
          },
          children: ["\u5546\u54C1\uFF1A\u3010", name, "\u3011\u542B\u7A0E\u9500\u552E\u4EF7\u683C\u4E0D\u5141\u8BB8\u4F4E\u4E8E\u542B\u7A0E\u5355\u4EF7\uFF0C\u8BF7\u4FEE\u6539\u7EA2\u8272\u63D0\u793A\u7684\u542B\u7A0E\u9500\u552E\u4EF7\u683C"]
        }),
        okButtonProps: {
          className: styles.ok
        },
        icon: /*#__PURE__*/_jsx(ExclamationCircleOutlined, {
          style: {
            color: 'rgba(247, 114, 52, 1)'
          }
        })
      });
      return;
    }
    (_ref$current3 = ref.current) === null || _ref$current3 === void 0 || _ref$current3.form.validateFields().then(function (values) {
      var modal = Modal.confirm({
        className: styles.modal,
        title: "\u786E\u8BA4".concat(text, "\u5417?"),
        content: /*#__PURE__*/_jsx("span", {
          style: {
            color: '#6E707A'
          },
          children: "\u8BF7\u4ED4\u7EC6\u6838\u5BF9\u4FE1\u606F\u786E\u8BA4\u65E0\u8BEF"
        }),
        icon: /*#__PURE__*/_jsx(ExclamationCircleOutlined, {
          style: {
            color: 'rgba(247, 114, 52, 1)'
          }
        }),
        okButtonProps: {
          className: styles.ok
        },
        cancelButtonProps: {
          className: styles.cancel
        },
        footer: /*#__PURE__*/_jsxs("div", {
          className: styles.filterFooter,
          children: [/*#__PURE__*/_jsx(Button, {
            onClick: function onClick() {
              return modal.destroy();
            },
            children: "\u53D6\u6D88"
          }), /*#__PURE__*/_jsx(Button, {
            type: "primary",
            onClick: function onClick() {
              var installContact = values.installContact,
                _values$installSuppli2 = values.installSupplier,
                installSupplier = _values$installSuppli2 === void 0 ? {} : _values$installSuppli2,
                orderLogistics = values.orderLogistics,
                arrivalDate = values.arrivalDate,
                shopContact = values.shopContact,
                attachment = values.attachment;
              post({
                url: "/erp/scm/purchase/".concat(path),
                data: _objectSpread(_objectSpread({}, data), {}, {
                  installContact: installContact || data.installContact ? _objectSpread(_objectSpread({}, data.installContact || {}), installContact || {}) : undefined,
                  arrivalDate: arrivalDate,
                  shopContact: data.shopContact || shopContact ? _objectSpread(_objectSpread({}, data.shopContact || {}), shopContact || {}) : undefined,
                  orderLogistics: data.orderLogistics || orderLogistics ? _objectSpread(_objectSpread({}, data.orderLogistics || {}), orderLogistics || {}) : undefined,
                  installSupplierCode: installSupplier.value || data.installSupplierCode,
                  installSupplierName: installSupplier.label || data.installSupplierName,
                  details: details,
                  attachment: attachment
                })
              }).then(function (result) {
                var code = result.code;
                if (code === 0) {
                  message.success('审核成功！');
                  getDetail();
                  modal.destroy();
                }
              }).catch(function () {});
            },
            children: "\u786E\u5B9A"
          })]
        })
      });
    }).catch(function () {});
  };
  var onReject = function onReject() {
    var modal = Modal.confirm({
      className: styles.modal,
      title: '确认拒绝吗?',
      content: /*#__PURE__*/_jsx(Form, {
        layout: "vertical",
        ref: ref2,
        mode: "edit",
        labelCol: {
          className: styles.label
        },
        children: /*#__PURE__*/_jsxs(Form.Field, {
          name: "remark",
          label: "\u62D2\u7EDD\u539F\u56E0",
          required: true,
          rules: [{
            required: true,
            message: '请输入拒绝原因'
          }],
          children: [/*#__PURE__*/_jsx(TextArea, {
            rows: 4,
            placeholder: "\u8BF7\u8F93\u5165\u62D2\u7EDD\u539F\u56E0"
          }), /*#__PURE__*/_jsx(TextArea, {
            rows: 4,
            placeholder: "\u8BF7\u8F93\u5165\u62D2\u7EDD\u539F\u56E0"
          })]
        })
      }),
      icon: /*#__PURE__*/_jsx(ExclamationCircleOutlined, {
        style: {
          color: 'rgba(247, 114, 52, 1)'
        }
      }),
      okButtonProps: {
        className: styles.ok
      },
      cancelButtonProps: {
        className: styles.cancel
      },
      footer: /*#__PURE__*/_jsxs("div", {
        className: styles.filterFooter,
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            return modal.destroy();
          },
          children: "\u53D6\u6D88"
        }), /*#__PURE__*/_jsx(Button, {
          type: "primary",
          onClick: function onClick() {
            var _ref2$current;
            (_ref2$current = ref2.current) === null || _ref2$current === void 0 || _ref2$current.form.validateFields().then(function (values) {
              post({
                url: "/erp/scm/purchase/reject",
                data: _objectSpread(_objectSpread({}, values), {}, {
                  orderCode: orderCode
                })
              }).then(function (result) {
                var code = result.code;
                if (code === 0) {
                  message.success('驳回成功！');
                  getDetail();
                  modal.destroy();
                }
              }).catch(function () {});
            }).catch(function () {});
          },
          children: "\u786E\u5B9A"
        })]
      })
    });
  };
  var onRebut = function onRebut() {
    var modal = Modal.confirm({
      className: styles.modal,
      title: '确认驳回吗?',
      content: /*#__PURE__*/_jsx(Form, {
        layout: "vertical",
        ref: ref2,
        mode: "edit",
        labelCol: {
          className: styles.label
        },
        children: /*#__PURE__*/_jsxs(Form.Field, {
          name: "remark",
          label: "\u9A73\u56DE\u539F\u56E0",
          required: true,
          rules: [{
            required: true,
            message: '请输入驳回原因'
          }],
          children: [/*#__PURE__*/_jsx(TextArea, {
            rows: 4,
            placeholder: "\u8BF7\u8F93\u5165\u9A73\u56DE\u539F\u56E0"
          }), /*#__PURE__*/_jsx(TextArea, {
            rows: 4,
            placeholder: "\u8BF7\u8F93\u5165\u9A73\u56DE\u539F\u56E0"
          })]
        })
      }),
      icon: /*#__PURE__*/_jsx(ExclamationCircleOutlined, {
        style: {
          color: 'rgba(247, 114, 52, 1)'
        }
      }),
      okButtonProps: {
        className: styles.ok
      },
      cancelButtonProps: {
        className: styles.cancel
      },
      footer: /*#__PURE__*/_jsxs("div", {
        className: styles.filterFooter,
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            return modal.destroy();
          },
          children: "\u53D6\u6D88"
        }), /*#__PURE__*/_jsx(Button, {
          type: "primary",
          onClick: function onClick() {
            var _ref2$current2;
            (_ref2$current2 = ref2.current) === null || _ref2$current2 === void 0 || _ref2$current2.form.validateFields().then(function (values) {
              post({
                url: "/erp/scm/purchase/rebut",
                data: _objectSpread(_objectSpread({}, values), {}, {
                  orderCode: orderCode
                })
              }).then(function (result) {
                var code = result.code;
                if (code === 0) {
                  message.success('驳回成功！');
                  getDetail();
                  modal.destroy();
                }
              }).catch(function () {});
            }).catch(function () {});
          },
          children: "\u786E\u5B9A"
        })]
      })
    });
  };
  var onExport = function onExport() {
    post({
      url: "/erp/scm/purchase/dtlExport",
      data: {
        orderCode: orderCode
      }
    }).then(function (result) {
      var code = result.code,
        d = result.data;
      if (code === 0) {
        window.open(d);
      }
    }).catch(function () {});
  };
  var openPriceDrawer = function openPriceDrawer(record) {
    setActiveRecord(record);
    setPriceVisible(true);
  };
  var onClosePrice = function onClosePrice() {
    setPriceVisible(false);
  };
  var openCodesDrawer = function openCodesDrawer(record) {
    setActiveRecord(record);
    setCodesVisible(true);
  };
  var onCloseCodes = function onCloseCodes(uniqKey, snCodes) {
    setCodesVisible(false);
    if (uniqKey && snCodes) {
      setDetails(details.map(function (e) {
        return _objectSpread(_objectSpread({}, e), {}, {
          snCodes: uniqKey === e.uniqKey ? snCodes : e.snCodes
        });
      }));
      setRenderDetails(renderDetails.map(function (e) {
        return _objectSpread(_objectSpread({}, e), {}, {
          snCodes: uniqKey === e.uniqKey ? snCodes : e.snCodes
        });
      }));
    }
  };
  var onPriceChange = function onPriceChange(data) {
    post({
      url: '/erp/scm/purchase/calcPrice',
      data: data
    }).then(function (result) {
      var code = result.code,
        d = result.data;
      if (code === 0) {
        setDetails(details.map(function (e) {
          return e.uniqKey === data.uniqKey ? _objectSpread(_objectSpread({}, e), d || {}) : e;
        }));
        setRenderKey(nanoid());
        setRenderDetails(renderDetails.map(function (e) {
          return e.uniqKey === data.uniqKey ? _objectSpread(_objectSpread({}, e), d || {}) : e;
        }));
      }
    }).catch(function () {});
  };
  var cols = data.showSalesColumn ? [{
    title: '含税销售单价',
    dataIndex: 'salesPrice',
    render: function render(v, record, index) {
      var value = valueProtectRender(v, record);
      return data.canEditSalesPrice && !record.salesDiscount ? /*#__PURE__*/_jsx(InputNumber, {
        defaultValue: value,
        style: {
          width: 150
        },
        className: Number(record.price) <= Number(v) ? undefined : styles.redInput,
        onBlur: function onBlur(e) {
          onPriceChange(_objectSpread(_objectSpread({}, record), {}, {
            salesPrice: Reg.test(e.target.value) ? Number(e.target.value).toFixed(2) : 0
          }));
        }
      }, "".concat(record.uniqKey, "-").concat(value, "-").concat(index, "-").concat(renderKey)) : /*#__PURE__*/_jsx("span", {
        style: {
          color: record.price != null && (record.price < v || record.salesDiscount) ? undefined : '#E60012'
        },
        children: record.salesDiscount ? '-' : value
      });
    }
  }, {
    title: '加成比例',
    dataIndex: 'salesDiscount',
    render: valueProtectRender
  }, {
    title: '含税销售金额',
    dataIndex: 'salesAmount',
    render: valueProtectRender
  }, {
    title: '含税销项税额',
    dataIndex: 'outputTaxAmount',
    render: valueProtectRender
  }] : [];
  var detailCol = [{
    title: '序号',
    dataIndex: 'flowOrderCode',
    width: 55,
    fixed: 'left',
    render: function render(a, b, index) {
      return index + 1;
    }
  }, {
    title: '商品编码',
    dataIndex: 'skuCode',
    fixed: 'left'
  }, {
    title: '商品名称',
    dataIndex: 'skuName',
    fixed: 'left'
  }, {
    title: '规格',
    dataIndex: 'spec'
  }, {
    title: '描述',
    dataIndex: 'description',
    className: styles.areaWidth,
    render: function render(v) {
      return /*#__PURE__*/_jsx(Popover, {
        style: {
          maxWidth: 400
        },
        content: /*#__PURE__*/_jsx("div", {
          style: {
            maxWidth: 400
          },
          children: /*#__PURE__*/_jsx(HtmlText, {
            children: v
          })
        }),
        trigger: "hover",
        children: /*#__PURE__*/_jsx("div", {
          className: styles.popText,
          children: v
        })
      });
    }
  }, {
    title: '单位',
    dataIndex: 'unit'
  }, {
    title: '数量',
    dataIndex: 'qty'
  }, {
    title: '发货数量',
    dataIndex: 'shipmentQty',
    render: function render(v, record, index) {
      return data.canEditShipmentQty ? /*#__PURE__*/_jsx(InputNumber, {
        style: {
          width: 150
        },
        defaultValue: v,
        onBlur: function onBlur(e) {
          onPriceChange({
            uniqKey: record.uniqKey,
            shipmentQty: Reg.test(e.target.value) ? Number(e.target.value) : 0
          });
        }
      }, "".concat(record.uniqKey, "-").concat(v, "-").concat(index, "-").concat(renderKey)) : v;
    }
  }, {
    title: '未税单价',
    dataIndex: 'noTaxPrice',
    render: valueProtectRender
  }, {
    title: '含税单价',
    dataIndex: 'price',
    render: function render(v, record, index) {
      var value = valueProtectRender(v, record);
      return data.canEditPrice ? /*#__PURE__*/_jsx(InputNumber, {
        defaultValue: value,
        style: {
          width: 150
        },
        className: record.priceChangeLogs && record.priceChangeLogs.length > 0 ? styles.redInput : undefined,
        onBlur: function onBlur(e) {
          onPriceChange(_objectSpread(_objectSpread({}, record), {}, {
            price: Reg.test(e.target.value) ? Number(e.target.value).toFixed(2) : 0
          }));
        }
      }, "".concat(record.uniqKey, "-").concat(value, "-").concat(index, "-").concat(renderKey)) : /*#__PURE__*/_jsx("span", {
        style: {
          color: record.priceChangeLogs && record.priceChangeLogs.length > 0 ? '#E60012' : undefined
        },
        children: value
      });
    }
  }, {
    title: '采购含税总金额',
    dataIndex: 'amount',
    render: valueProtectRender
  }, {
    title: '发货含税总金额',
    dataIndex: 'shipmentAmount',
    render: valueProtectRender
  }, {
    title: '税率',
    dataIndex: 'taxRate',
    render: function render(v, r) {
      return v ? valueProtectRender("".concat(v, "%"), r) : v;
    }
  }, {
    title: '采购税额',
    dataIndex: 'taxAmount',
    render: valueProtectRender
  }, {
    title: '发货税额',
    dataIndex: 'shipmentTaxAmount',
    render: valueProtectRender
  }].concat(cols, [{
    title: '是否定制品',
    dataIndex: 'customized',
    render: function render(v) {
      return /*#__PURE__*/_jsxs("div", {
        className: styles.customized,
        children: [/*#__PURE__*/_jsx("div", {
          className: v === 2 ? styles.grayIcon : styles.redIcon
        }), /*#__PURE__*/_jsx(DictText, {
          dictType: "scm_is_customized",
          value: v
        })]
      });
    }
  }, {
    title: '备注',
    dataIndex: 'remark',
    className: styles.areaWidth,
    render: function render(v) {
      return /*#__PURE__*/_jsx(Popover, {
        style: {
          maxWidth: 400
        },
        content: /*#__PURE__*/_jsx("div", {
          style: {
            maxWidth: 400
          },
          children: /*#__PURE__*/_jsx(HtmlText, {
            children: v
          })
        }),
        trigger: "hover",
        children: /*#__PURE__*/_jsx("div", {
          className: styles.popText,
          children: v
        })
      });
    }
  }, {
    title: '商品序列号',
    dataIndex: 'snCodes',
    align: 'center',
    render: function render(v, record) {
      return /*#__PURE__*/_jsx("span", {
        className: styles.edit,
        onClick: function onClick() {
          return openCodesDrawer(record);
        },
        children: "\u5F55\u5165"
      });
    }
  }, {
    title: '附件',
    dataIndex: 'attachment',
    align: 'center',
    render: function render(v, record) {
      return v && v.length ? /*#__PURE__*/_jsx("span", {
        className: styles.edit,
        onClick: function onClick() {
          Modal.confirm({
            title: '附件信息',
            icon: null,
            closable: true,
            width: 600,
            content: /*#__PURE__*/_jsx(UploadWithFilename, {
              className: styles.linkFile,
              value: v,
              disabled: true,
              listType: "text"
            }),
            footer: /*#__PURE__*/_jsx(_Fragment, {})
          });
        },
        children: "\u67E5\u770B"
      }) : '-';
    }
  }, {
    title: '变价记录',
    dataIndex: 'priceChangeLogs',
    align: 'center',
    render: function render(v, record) {
      return v && v.length && allowShowPrice ? /*#__PURE__*/_jsx("span", {
        className: styles.edit,
        onClick: function onClick() {
          return openPriceDrawer(record);
        },
        children: "\u67E5\u770B"
      }) : '-';
    }
  }]);
  return {
    data: {
      ref: ref,
      allowShowPrice: allowShowPrice,
      searchText: searchText,
      orderCode: orderCode,
      data: data,
      summary: summary,
      renderDetails: renderDetails,
      detailCol: detailCol,
      activeRecord: activeRecord,
      priceVisible: priceVisible,
      codesVisible: codesVisible
    },
    action: {
      onSave: onSave,
      onSubmit: onSubmit,
      onExport: onExport,
      onReject: onReject,
      onRebut: onRebut,
      onSearchDetail: onSearchDetail,
      setSearchText: setSearchText,
      onClosePrice: onClosePrice,
      onCloseCodes: onCloseCodes
    }
  };
};